<section class="border-y border-slate-100 bg-[#F7F9FF] py-14">
  <div class="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-4 sm:px-5 md:grid-cols-2 md:px-0 xl:grid-cols-4 xl:gap-6">
    @for (metric of metrics; track metric.label) {
      <div class="flex min-h-[104px] items-center justify-center rounded-[1.5rem] border border-blue-100 bg-[#F4F7FF] px-6 py-5 text-center shadow-[0px_1px_2px_-1px_rgba(37,99,235,0.10)] shadow-[0px_8px_24px_rgba(37,99,235,0.08)]">
        <div>
          <p class="text-[1.75rem] font-semibold leading-none tracking-[-0.03em] text-blue-700 font-['Inter']">
            {{ metric.value }}
          </p>
          <p class="mt-2 text-[1.05rem] font-medium leading-snug text-blue-700 font-['Inter']">
            {{ metric.label }}
          </p>
        </div>
      </div>
    }
  </div>
</section>
